module.exports = __webpack_public_path__ + "media/images/favicon/favicon-2a0714d14b74869fb7fdabfe1982798b.ico";